import { createSlice } from '@reduxjs/toolkit';
import { device } from '../../utils/helpers';

export interface NodeStyles {
  loadingNode: { display: string };
  loadingAnimationNode: { display: string };
  fileUploadArea: { display: string, borderColor: string };
  settingsCenterStyles: { display: string, position: string };
  imageListWrapperStyles: { display: string };
  mobileBtnsStyles: { display: string };
  viewerMainStyles: { height: string };
  errorMsgStyles: { display: string };
}

const _device = device();
const initialState: NodeStyles = {
  loadingNode: { display: "none" },
  loadingAnimationNode: { display: "block" },
  fileUploadArea: { display: "flex", borderColor: "#ddd" },
  settingsCenterStyles: { display: _device === "mobile" ? "none" : "block", position: "relative" },
  imageListWrapperStyles: { display: _device !== "mobile" ? "block" : "none" },
  mobileBtnsStyles: { display: _device === "mobile" ? "flex" : "none" },
  errorMsgStyles: { display: "none" },
  viewerMainStyles: (() => {
    if (_device === "pc") {
      return { height: "calc(100% - 190px)" };
    } else if (_device === "ipad") {
      return { height: "calc(100% - 170px)" };
    } else {
      return { height: "100%" }
    }
  })()
};

const generalStatesSlice = createSlice({
  name: "generaState",
  initialState,
  reducers: {
    updateStyles: (state, action: { payload: { [nodeName: string]: any } }) => {
      for (let nodeName in action.payload) {
        state[nodeName as keyof NodeStyles] = action.payload[nodeName];
      }
      return state;
    },
  },
});

export const { updateStyles } = generalStatesSlice.actions;

export default generalStatesSlice.reducer;